function handleSitePopup() {
  function shouldShowPopup() {
    return !document.cookie.includes('popupShown=true');
  }

  // Function to show the popup
  function showPopup() {
    const popup = document.getElementById('popup');
    if (shouldShowPopup()) {
      popup.style.display = 'block';
    }
  }

  // Function to close the popup and set a cookie
  function closePopup() {
    const popup = document.getElementById('popup');
    popup.style.display = 'none';

    // Set a cookie to prevent the popup from showing again
    document.cookie = 'popupShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
  }

  // Add click event listeners
  showPopup();
  document.getElementById('close-popup').addEventListener('click', closePopup);

  const buttons = document.querySelectorAll('.popup-buttons a');

  if (buttons.length > 0) {
    buttons.forEach((btn) =>
      btn.addEventListener('click', () => {
        closePopup();
      }),
    );
  }
}

window.addEventListener('load', () => {
  const appPopup = document.querySelector('.app-site-popup');

  if (appPopup) {
    // Disabled in DGS-4541
    // handleSitePopup();
  }
});
